import { _onboarding } from "./LocalForage";

export const ACCESS_TOKEN_KEY = btoa("access_token");

export const setAccessToken = async (token: string) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  await _onboarding.setItem(ACCESS_TOKEN_KEY, token);
};

export const isAuthenticated = async () => {
  const token = await getAccessToken();
  return !!token;
};

export const clearLocalStorage = async () => {
  localStorage.clear();
  await _onboarding.clear();
};

export const getAccessToken = async () => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  const token2 = (await _onboarding.getItem(ACCESS_TOKEN_KEY)) as string;
  return token || token2 || "";
};
